import { AdminSwitch, Box, SubTitleWithTooltipIcon } from '@vgrubs/components';
import { useChatTriagePilot } from './hooks/useChatTriagePilot';

type Props = {
  locationId: number;
};

/**
 * Whether the AI assistant reads this merchant's support messages.
 *
 * The pilot switch is the whole rollout: the bot does nothing for a location
 * that is not in it. It saves on its own the moment it is flipped, not with
 * the Edit Location submit, because it is a separate endpoint and a rollout
 * decision rather than a location field. The copy has to be exact about the
 * limit of what the bot can do on its own, because a merchant who has not yet
 * been told about any of this will meet it as a card in their support thread.
 */
export const ChatTriagePilotToggle = ({ locationId }: Props) => {
  const { isOn, isLoading, busy, toggle } = useChatTriagePilot(
    locationId,
    !Number.isNaN(locationId)
  );

  return (
    <Box
      $flex
      $alignCenter
      $between
      $gap="16px"
      $p="24px"
      $pSM="20px"
      $width="100%"
      $mb="24"
    >
      <SubTitleWithTooltipIcon
        mb="0"
        text={'AI Chat Assistant (Pilot)'}
        tooltip={`
          When on, the assistant reads this merchant's support messages and can propose pausing orders, changing hours or prep time, and pausing menu items. Nothing changes until the merchant confirms. Order and refund requests become tickets for the support team. Saves immediately.
        `}
      />

      <AdminSwitch
        checked={isOn}
        disabled={busy || isLoading}
        onChange={(event) => toggle(event.target.checked)}
      />
    </Box>
  );
};
